
import Vue from 'vue';
import { mapState } from 'vuex';
import SetUpSection from './components/SetUpSection.vue';
import ReferEarnSection from './components/ReferEarnSection.vue';
import ListItem from '@/components/base/ListItem.vue';
import { MyBalanceMixin } from '@/mixins';
import { ROUTER } from '@/router/constants';
// import ConnectEarnSection from './components/ConnectEarnSection.vue';

export default Vue.extend({
	name: 'ReferralPage',
	metaInfo: {
		title: 'Reward Program',
	},
	mixins: [
		MyBalanceMixin,
	],
	data () {
		return {
			ROUTER,
		};
	},
	components: {
		SetUpSection,
		ReferEarnSection,
		ListItem,
		// ConnectEarnSection,
	},
	computed: {
		...mapState([
			'user',
		]),
		showSetupSection() {
			return this._get(this.user, 'clubOffer.isFreemium', false);
		},
	},
	methods: {},
});
